import { useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  useMediaQuery,
  Card,
  Button,
  IconButton,
  Chip,
  Rating
} from "@mui/material";
import { extractContent } from '../../logic/Utils';
import { makeStyles, useTheme } from "@mui/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Carousel from "react-elastic-carousel";
import { StarBorder, Star } from "@mui/icons-material";
import SectionLayout from "../../layout/SectionLayout";
import determineFileType from 'src/screens/Partners/Courses/hook/checkfileType';
import { SectionTitle, SectionSubtitle } from "../../../Template3/components/SectionTitle";
import NoImage from "src/assets/images/no-pictures.png";
import AvatarImg from "src/assets/images/placeholder.png";
import RiyalIcon from "src/assets/images/welcome/riyal.svg";
import { getLocalizedText } from "../../logic/Utils";
import useServiceCard from "../../logic/useServiceCard";
import { textVariant, textClasses } from "../../config";
import { position } from 'stylis';

const useStyles = makeStyles((theme) => ({
  carouselContainer:(props) => ({
      position: "relative",
      width: "100%",
      '& .rec-carousel':{
        minHeight:'500px'
      },
      "& .rec-carousel-item": {
        // ensure all cards have the same width/height
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      padding:'10px 0px'

      },
      "& .rec-carousel-wrapper": {
        padding: "1rem 0", // top/bottom spacing around the track
      },
      "& .rec-item-wrapper": {
        width: 'fit-content !important',
        margin:'0px 20px',
        borderRadius: props?.cardRadius || '0px',
        transition: 'all 0.3s ease-in-out',
        boxShadow: "0px 3px 20px #1107291A",
        border: props?.border || '1px solid #F1F1F1',
        overflow: "hidden",
          "&:hover": {
          boxShadow: "none",
        },

           '&:hover .moreDetailsBtn': {
                display: 'flex',
                opacity: 1,
                transform: 'translateY(0)',
                pointerEvents: 'auto',
            },
      },
      "& .rec-arrow": {
        // override default arrow style from react-elastic-carousel
        backgroundColor: "rgba(255,255,255,0.8)",
        "&:hover": {
          backgroundColor: "rgba(255,255,255,1)",
        },
        boxShadow: "0px 3px 20px #0000001A",
      },
    "& .rec-pagination": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "1rem",
      gap: "0.5rem",

      "& .rec-dot": {
        width: "7px",
        height: "7px",
        borderRadius: "50%",
        backgroundColor: "#110729", // Inactive dot
        border: "none",
        position: "relative",
        transition: "all 0.3s ease",
      boxShadow:'none',

        "&:focus": {
          outline: "none",
          boxShadow: "none",
        },
      },

      "& .rec-dot_active": {
        backgroundColor: "transparent",
        border: "1px solid #110729",
        width:'15px',
        height:'15px',
        "&::after": {
          content: '""',
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "7px",
          height: "7px",
          borderRadius: "50%",
          backgroundColor: "#4A4266",
        },
      },
    }

  }),

  rootContainer: {
    width: "100%",
    backgroundColor: "#FFFFFF", 
  },
  headingsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    textAlign: "center",
    marginBottom: theme.spacing(4),
  },
  arrowButtonPrev: {
    position: "absolute !important",
    left: -20,
    top: "45%",
    zIndex: 10,
  },
  arrowButtonNext: {
    position: "absolute !important",
    right: -20,
    top: "45%",
    zIndex: 10,
  },
  viewAllWrapper: {
    display: "flex",
    justifyContent: "flex-end",
  },
 viewAllButton: {
    backgroundColor: '#FFFFFF',
    borderRadius: 0,
    padding: `${theme.spacing(1.5)} ${theme.spacing(4)}`,
    border:'1px solid #F2F2F2',
    color:'#0F2240',
    textTransform: "capitalize",
    fontWeight: 600,
    fontSize: "18px",
    transition: "background-color 0.3s ease",
    cursor: "pointer",
    width:'calc(229px - 48px)',
    height:63,
    "&:hover": {
      backgroundColor: '#0000001a',
    }
  },
 
  cardRoot:(props) => ({
    minWidth: "303px",
    maxWidth: "303px",
    maxHeight: 285,
    minHeight: 285,
    display: "flex",
    borderRadius: props?.cardRadius || '0px',
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    boxShadow: "none",
    transition: "transform 0.3s, box-shadow 0.3s",
    "&:hover": {
        transform: "scale(1.03)",
        // boxShadow: "3px 6px 10px rgba(0,0,0,0.1)",
    },
  }),
  
  cardTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#0F2240",
    textTransform: "capitalize",
  },

  instructorImage: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    boxShadow: '0px 3px 6px #00000029',
    border:'1px solid #fff',
    backgroundColor: '#fff',
  },

  mainComp: props => ({
    width: 300,
    overflow: 'hidden',
    cursor: 'pointer',
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    transition: "transform 0.3s, box-shadow 0.3s",
    '&:hover': {
      transform: 'scale(1.02)',
    },

    // '&:hover .moreDetailsBtn': {
    //   display: 'flex',
    // },
  }),
  imageBox: {
    width:"220px",
    height: '100%',
    flexShrink: 0,
    borderRadius: '0px',
    overflow: 'hidden',
    position: 'relative'
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  chip: props => ({
    position: 'absolute',
    top: 0,
    ...(props?.isRTL ? { right: 0 } : { left: 0 }),
    background: '#4B4B4BA6',
    textTransform: 'capitalize',
    color: '#fff',
    fontSize: '12px',
    height:'24px',
    borderRadius: '0px',
  }),
  instructor: {
    width: 34,
    height: 34,
    borderRadius: '50%',
    boxShadow: '0px 3px 6px #00000029',
    border:'1px solid #fff',
    backgroundColor: '#fff',
  },
  instructorRow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 8,
  },

  hoverBtn: {
       position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#0F2240',
      color: '#fff',
      textAlign: 'center',
    //   py: 1,
      fontWeight: 600,
      opacity: 0,
      transform: 'translateY(100%)',
      transition: 'all 0.3s ease-in-out',
      pointerEvents: 'none',
  }
}));

export function Courses({
  courses,
  services,
  t,
  handleExploreServices,
  handleExploreCategories,
  productType,
  data: dataObj,
  mainColor,
  contentData,
  index
}) {
  const classes = useStyles();
  const theme = useTheme();
  const matchesMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isMounted = useRef(false);
  const { chatgptContent } = dataObj || {};
  const companyId = dataObj?.companyData?.companyId || "";

  // 1) Titles / subtitles from contentData (or fallback)
  const {
    maxDisplayItems,
      productDisplayHorizontal = true,
      backgroundColor,
      backgroundImage,
      backgroundStyle,
      title,
      arTitle,
      subTitle,
      arSubTitle,
      titleFormat,
      titleFontSize,
      subTitleFontSize,
      titleFontColor,
      subTitleFontColor,
      paddingTop,
      paddingBottom,
      displayProductDesc
  } = contentData || {};
  const displayDescription = displayProductDesc !== undefined ? displayProductDesc : true;

  const maxServiceShow = maxDisplayItems ? maxDisplayItems : null;


  const isRTL = dataObj?.isRTL === "ar";
 const _title = title
   ? getLocalizedText(title, arTitle)
    : productType === 'services'
   ? t?.("companyPage.services")
   : t?.("companyPage.courses");
 
    const _subTitle = subTitle
     ? getLocalizedText(subTitle, arSubTitle)
      : productType === 'services'
    ? t?.("companyPage.findService")
     : t?.("companyPage.findCourses");

  // 2) Filter logic
   const servicesDuplicate = services?.length
    ? JSON.parse(JSON.stringify(services))
    : [];

    const filterService =
    servicesDuplicate.length && contentData.categoryId
    ? servicesDuplicate.filter((v) => v.serviceCategoryId === contentData.categoryId)
    : servicesDuplicate;

  const coursesCopy = courses && courses.length ? [...courses] : [];
  const filterByCat =
    coursesCopy.length && contentData?.categoryId
      ? coursesCopy.filter(
          (course) => course.courseCategoryId === contentData.categoryId
        )
      : coursesCopy;

  const selectedCats = contentData?.selectedCategories || [];
//   const filteredCategories =
//     selectedCats.length && categories
//       ? categories.filter((cat) => selectedCats.includes(cat.id))
//       : categories || [];

  const renderList = productType === 'services' ? filterService : filterByCat;


  const limitedList = maxServiceShow ? renderList.slice(0, maxServiceShow) : renderList;

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  if (!limitedList || limitedList.length === 0) {
    return null;
  }

  // 3) Carousel breakpoints
  const breakPoints = [
    { width: 0, itemsToShow: 1 },
    { width: 600, itemsToShow: 2 },
    { width: 900, itemsToShow: 3 },
    { width: 1200, itemsToShow: 5 },
  ];

  return (
    <Box
      className={classes.rootContainer}
      dir={isRTL ? "rtl" : "ltr"}
      style={{
        ...(backgroundStyle === "image" && backgroundImage
          ? {
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }
          : backgroundStyle === "gradient"
          ? { backgroundImage: backgroundColor }
          : { backgroundColor: backgroundColor || "#FFFFFF" }),
      }}
    >
      <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
        {/* Centered Headings */}
        <Box className={classes.headingsContainer}>
          <SectionSubtitle
            visibleHorizontalLine={true}
            pFontSize={subTitleFontSize}
            color={subTitleFontColor}
            mainColor={mainColor}
          >
            {_title}
          </SectionSubtitle>
          <SectionTitle
            pFontSize={titleFontSize}
            color={titleFontColor}
            variant={titleFormat}
          >
            {_subTitle}
          </SectionTitle>
        </Box>

        {/* Carousel */}
       <Box pb={3} display="flex" flexDirection={!productDisplayHorizontal ? 'row' : 'unset'} flexWrap={!productDisplayHorizontal ? 'wrap' : 'unset'} justifyContent="center">
                 
        <Carousel
        className={classes.carouselContainer}
        breakPoints={breakPoints}
        pagination={true}
        // itemPadding={[5, 10]}
        renderArrow={(arrowProps) => {
            const { type, onClick, isEdge } = arrowProps;
            return type === "PREV" ? (
            <IconButton
                onClick={onClick}
                disabled={isEdge}
                className={classes.arrowButtonPrev}
                size="small"
            >
                <ArrowBackIosIcon fontSize="small" />
            </IconButton>
            ) : (
            <IconButton
                onClick={onClick}
                disabled={isEdge}
                className={classes.arrowButtonNext}
                size="small"
            >
                <ArrowForwardIosIcon fontSize="small" />
            </IconButton>
            );
        }}
        >
          
            {limitedList.map((item, idx) => {
              // Determine localized name
              const displayName =
                chatgptContent && Object.keys(chatgptContent).length
                  ? isRTL
                    ? chatgptContent.arabic[`section${index}`][idx].title
                    : chatgptContent.english[`section${index}`][idx].title
                  : productType === 'services' ? item.name : item?.enName;

              // Pass down a “service” prop with name + image
              const serviceWithName = {
                ...item,
                name: displayName,
                description: productType === 'services' ? item?.shortDescription : item?.description || '',
              };

              return (
                <ServiceCard
                  key={idx}
                  service={serviceWithName}
                  productType={productType}
                  companyId={companyId}
                  contentData={contentData}
                  displayDescription={displayDescription}
                  isRTL={isRTL}
                  t={t}
                />
              );
            })}
        </Carousel>
        </Box>

        {/* “View All →” Button */}
        <Box className={classes.viewAllWrapper}>
          <Button
            disableElevation
            className={classes.viewAllButton}
            onClick={() =>
              productType === "categories"
                ? handleExploreCategories()
                : handleExploreServices()
            }
          >
            {t && t("services.viewAll")}
          </Button>
        </Box>
      </SectionLayout>
    </Box>
  );
}

function ServiceCard({ service, productType="courses", companyId, contentData, isRTL, displayDescription, t }) {
  const theme = useTheme();
  const courseDeliver = productType === 'services' ? service?.serviceDeliver : service?.courseDeliver;
  const { handleClick, rating, reviews, instructor } = useServiceCard({service,productType,companyId, courseDeliver});
    const matches = useMediaQuery(theme.breakpoints.down('lg'));
    const maxStringLength = matches ? 80 : 130;
  const titleFontSize = contentData?.cardTitleFontSize ?? '18';
  const descriptionFontSize = contentData?.cardTextFontSize ?? '14';

  const titleFontColor = contentData?.cardTitleColor ?? '';
  const descFontColor = contentData?.cardTextColor ?? '#6B7385';
  const cardRadius = contentData?.cardRadius ? `${contentData.cardRadius}px` : null;
  const cardBorder = contentData?.border || '1px solid #F1F1F1';
  const classes = useStyles({border:cardBorder,cardRadius,isRTL});

  const shortDescription = extractContent(service?.description);

  const fileType = determineFileType(service?.cover);

  // button
  const _buttonColor = contentData?.buttonColor ? contentData?.buttonColor : '#0C3147';
  const _buttonFontColor = contentData?.buttonFontColor ? contentData?.buttonFontColor : '#FFFFFF';
  const _buttonFontSize = contentData?.buttonFontSize ? contentData?.buttonFontSize : '12';
  const _buttonWidth = contentData?.autoButtonSize ? '100%' : contentData?.buttonWidth ? `${contentData?.buttonWidth}px` : '100%';
  const _buttonHeight = contentData?.buttonHeight ? `${contentData?.buttonHeight}px` : null;
  const btnRadius = contentData?.buttonRadius ? `${contentData?.buttonRadius}px` : '0px'; 
    return (
<Box
className={classes.mainComp}
  onClick={handleClick}
   style={{
        cursor: 'pointer',
        ...((contentData?.cardBackgroundStyle === 'image' && contentData?.cardBackgroundImage) ? 
          {
              backgroundSize: "cover",
              backgroundImage: `url(${contentData?.cardBackgroundImage})`,
              backgroundRepeat: "no-repeat",
          } 
        : 
        (contentData?.cardBackgroundStyle === 'gradient' && contentData?.cardBackgroundColor) ? 
          {
              backgroundImage: contentData?.cardBackgroundColor ? contentData?.cardBackgroundColor : '#ffffff',
          } 
        :
        (contentData?.cardBackgroundStyle === 'solidColor' && contentData?.cardBackgroundColor) ? 
          {
              backgroundColor: contentData?.cardBackgroundColor || '#fff',
          } 
        : 
          {backgroundColor: '#fff'}
        ),
        overflow:'hidden'
      }}
>
  {/* Image Section */}
  <Box sx={{ position: 'relative' }}>
    <img
      src={service?.cover || NoImage}
      alt="Course"
      style={{
        width: '100%',
        height: '187px',
        objectFit: 'cover',
        display: 'block',
      }}
    />
    {service?.courseCategory || service?.serviceCategory ? (
    <Chip
      label={service?.courseCategory || service?.serviceCategory}
      className={classes.chip}
      size="small"
    />
    ) : null}
  </Box>

  {/* Body Section */}
  <Box
    px={2}
    py={2}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1, // makes card heights consistent
    }}
  >
    {/* Text block */}
    <Box sx={{ flexGrow: 1 }}>
        <Typography
            variant={textVariant?.[titleFontSize]}
            className={`twoLineTxt ${classes.cardTitle} ${textClasses?.[titleFontSize]}`}
            style={{
                color: titleFontColor || "#0F2240",
                fontWeight: 'bold',
                marginBottom:'5px',
                minHeight: 'calc(1.5em * 2)',
            }}
        >
            {service?.name || '---'}
        </Typography>

    {displayDescription ?
        <Typography variant={textVariant?.[descriptionFontSize]} style={{ opacity: '0.7',...(descFontColor ? {color:descFontColor} : {}) }} minHeight="calc(1.5em * 2)" className={`twoLineTxt ${textClasses?.[descriptionFontSize]}`}>
            {shortDescription?.substring(0, maxStringLength)}
            {shortDescription  ? shortDescription?.length > maxStringLength && '...' : ''}
        </Typography>
    : null }

      <Box mt={1}>
        <Rating
          name="read-only"
          defaultValue={0}
          value={rating}
          precision={0.1}
          readOnly
          icon={<Star sx={{ color: '#fac400', fontSize: 20 }} />}
          emptyIcon={<StarBorder sx={{ color: '#fac400', fontSize: 20 }} />}
        />
      </Box>
    </Box>

    {/* Bottom: Instructor and Price */}
    <Box
      mt={2}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box display="flex" alignItems="center">
        <img
          src={service?.instructorImage || AvatarImg}
          alt="Instructor"
          className={classes.instructor}
        style={{...(isRTL ? {marginLeft:8} : {marginRight:8})}}

        />
        <Typography fontSize={12} fontWeight={600} color="#0F2240" textTransform="capitalize">
          {instructor ? `${instructor?.firstName || '---'} ${instructor?.lastName || '---'}` : '---'}
        </Typography>
      </Box>

        {service?.currency === 'SAR' ?
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <img src={RiyalIcon} alt="Riyal" style={{ width: 16, height: 16, marginRight: 4 }} />
                <Typography fontWeight="bold" fontSize={18}>{service?.price || null}</Typography>
            </Box>    
        :
        service?.currency && service?.price ?
            <Typography fontWeight="bold" fontSize={18} noWrap overflow="unset">
                {`${service?.currency} ${service?.price}`}
            </Typography>
        : 
        <Typography fontWeight="bold" fontSize={18} noWrap overflow="unset">
            {t?.('activityPage.free')}
        </Typography>
        }
    </Box>

     <Box
        className="moreDetailsBtn"
        sx={{
            mt: 2,
            opacity: 0,
            transform: 'translateY(10px)',
            transition: 'all 0.3s ease-in-out',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            py: 1,
            fontWeight: 'bold',
            cursor: 'pointer',
            display: 'none', // hidden by default
            pointerEvents: 'none', // avoid clicks when hidden

            backgroundColor:_buttonColor,
            color: _buttonFontColor,
            fontSize:_buttonFontSize,
            width:_buttonWidth,
            ...(_buttonHeight ? {height:_buttonHeight} : {}),
            borderRadius: btnRadius,
        }}
        >
        {t && t('companyPage.moreDetail')}
        </Box>
  </Box>
</Box>
    );
}